import { render, staticRenderFns } from "./DetailsCell.vue?vue&type=template&id=3e390a96&"
import script from "./DetailsCell.vue?vue&type=script&lang=js&"
export * from "./DetailsCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports